const URL = process.env.NODE_ENV !== 'production' ? 'http://localhost:8080' : 'https://devflix-api-6c587a9adc78.herokuapp.com';

export default {
  URL,
};
